import React from 'react'
import { Animated } from 'react-animated-css'
import { Carousel, Button, Modal } from 'react-bootstrap'
// import window from "global";
const FilteredResult = (props) => {
  const {
    click,
    noProjectsMessage,
    projects,
    getProjectDetails,
    show,
    handleClose,
    selectedProject,
    selectedButton,
    splitClientsData,
    width,
  } = props
  let numberOfSlides = width > 1394 ? 7 : width > 1150 ? 6 : width > 900 ? 5 : 4
  return (
    <div className="scrl">
      <div className="">
        <div className="separator" />
        <div className="row" data-animation-effect="In">
          <div className="col-md-12 col-lg-12">
            <div className="isotope-container center row ">
              <div
                id="wbitems"
                className="da-slider isotope-item-openPositions wb"
              >
                <div className="da-slide open-positions-da-slide">
                  <Animated
                    key={'filteredResult'}
                    animationIn="fadeInRight"
                    animationOut="fadeOut"
                    isVisible
                  >
                    {click && noProjectsMessage ? (
                      <div className="text-center text-color-black">
                        There are no opennings currently for this role
                      </div>
                    ) : projects.length < 9 ? (
                      projects.map((project, index) =>
                        project.title !== undefined
                          ? getProjectDetails(project, index, '')
                          : null
                      )
                    ) : (
                      <Carousel
                        id={selectedButton}
                        indicators={projects.length > numberOfSlides}
                        controls={projects.length > numberOfSlides}
                        className="carousel-style"
                        interval={4000}
                      >
                        {splitClientsData(numberOfSlides).map((item, index) => (
                          <Carousel.Item
                            key={index + selectedButton}
                            active={index === 1}
                          >
                            {item}
                          </Carousel.Item>
                        ))}
                      </Carousel>
                    )}
                  </Animated>
                  <Modal
                    id="modalPopup"
                    show={show}
                    onHide={() => handleClose()}
                    bsSize="large"
                    aria-labelledby="contained-modal-title-lg"
                  >
                    <Modal.Header closeButton>
                      <Modal.Title
                        id="contained-modal-title-lg"
                        className="text-color-black"
                      >
                        {selectedProject.title} - {selectedProject.workLocation}{' '}
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="row">
                        <div className="col-md-6 col-lg-6">
                          <p>
                            <b>Experience: </b>
                            {selectedProject.experience}
                          </p>
                          <p>
                            <b>Education: </b>
                            {selectedProject.education}
                          </p>
                          <p>
                            <b>Work Location: </b>
                            {selectedProject.workLocation}
                          </p>
                          {selectedProject.details.requirements ? (
                            <p>
                              <b>Requirements: </b>
                              {selectedProject.details.requirements}
                            </p>
                          ) : null}
                          {selectedProject.details.mustHave ? (
                            <p>
                              <b>Must Have: </b>
                              {selectedProject.details.mustHave.map(
                                (item, index) => {
                                  return <li key={index}>{item}</li>
                                }
                              )}
                            </p>
                          ) : null}
                          {selectedProject.details.goodToHave ? (
                            <p>
                              <b>Good To Have: </b>
                              {selectedProject.details.goodToHave.map(
                                (item, index) => {
                                  return <li key={index}>{item}</li>
                                }
                              )}
                            </p>
                          ) : null}
                          <div className="space" />
                          <div>
                            <p>
                              Please send resume by e-mail to:{' '}
                              <b>
                                <a href="mailto:resumes@nichesolv.com">
                                  resumes@nichesolv.com
                                </a>
                              </b>
                            </p>
                            What you can look forward at NicheSolv:
                            <ul>
                              <li>Industry Standard Remuneration / Salary</li>
                              <li>Great Learning Place</li>
                              <li>Work - Life Balance</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button onClick={() => handleClose()}>Close</Button>
                    </Modal.Footer>
                  </Modal>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default FilteredResult



// WEBPACK FOOTER //
// /home/reetika/Desktop/nichesolvweb/website/nswebsite/src/containers/careers/FilteredResult/FilteredResult.js